export const SHARED_BUFFER_RECORD_WORKER_FACTORY = 'sharedBufferRecordWorker';

export const SHARED_BUFFER_TRANSPORT_FACTORY = 'sharedBufferTransportFactory';
